import React from 'react';
import Step from "components/MainApp/atoms/Wizard/Step";


import styles from "./Step3.module.scss";
import i18n from 'i18n';

export class AddDeviceStepThree extends React.Component {
  render() {
    const {deviceInfo, handleFinish } = this.props;

    const stepContent = (
      <form onSubmit={handleFinish}>
      <div className={styles["add-device-wizard-step-three-content"]}>
        {deviceInfo.map( (item, index) => {
          return <div key={index} className={styles["add-device-wizard-step-three-item"]}> 
            <div className={styles["add-device-wizard-step-three-title"]}>{item.title}</div>
            <div className={styles["add-device-wizard-step-three-value"]}>{item.value}</div>
          </div>
        })}
        <div className={styles["add-device-wizard-step-three-action-wrapper"]}>
          <button type="submit" className={styles["add-device-wizard-step-three-action-button"]}>
            {i18n.t("finish").toUpperCase()}
          </button>
        </div>
      </div>
      </form>
    );

    return (
      <div className={styles["add-device-wizard-step-three-container"]}>
        <Step title={i18n.t("device")} content={stepContent} ></Step>
      </div>
    );
  }
}

export default AddDeviceStepThree;
